import { useState } from "react";
import { ShoppingBag } from "lucide-react";
import { eur } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { SizeGuide } from "@/components/SizeGuide";

const short = (n) => n.replace("FAUNNY GEAR ", "").toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());

export const PackPicker = ({ p, qty = 1 }) => {
  const { add } = useCart();
  const sized = (p.bundle_items || []).filter((c) => c.formats.length > 1);
  const [sel, setSel] = useState({});
  const ready = sized.every((c) => sel[c.slug]);
  const pick = () => {
    const ids = sized.map((c) => sel[c.slug]);
    const label = p.bundle_items.map((c) => (c.formats.length > 1 ? `${short(c.name)} ${c.formats.find((f) => f.id === sel[c.slug]).label}` : short(c.name))).join(" · ");
    add(p, { id: ids.length ? `pack:${ids.join(",")}` : "pack", label, price: p.formats[0].price }, qty);
  };
  return (
    <div data-testid="pack-picker">
      <p className="text-sm text-slate-600 mt-6">Incluye: <b className="text-[#0B1D3A]">{(p.bundle_items || []).map((c) => short(c.name)).join(" + ")}</b></p>
      {sized.length > 0 && <div className="mt-3"><SizeGuide /></div>}
      {sized.map((c) => (
        <div key={c.slug} className="mt-4">
          <p className="font-display font-bold text-[#0B1D3A]">Talla {short(c.name)}</p>
          <div className="flex flex-wrap gap-2 mt-2">
            {c.formats.map((f) => (
              <button key={f.id} disabled={f.stock <= 0} onClick={() => setSel({ ...sel, [c.slug]: f.id })} data-testid={`pack-size-${c.slug}-${f.id}`}
                className={`min-w-[3rem] h-10 px-3 rounded-full border text-sm font-bold transition-colors disabled:opacity-30 disabled:line-through ${sel[c.slug] === f.id ? "bg-[#0B1D3A] border-[#0B1D3A] text-white" : "border-slate-300 text-[#0B1D3A] hover:border-[#0B1D3A]"}`}>{f.label}</button>
            ))}
          </div>
        </div>
      ))}
      <div className="mt-6 flex items-baseline gap-3">
        <span className="text-4xl font-extrabold text-[#DC2626]" data-testid="pack-price">{eur(p.formats[0].price)}</span>
        {p.compare_price > p.formats[0].price && <span className="text-lg text-slate-400 line-through" data-testid="pack-compare-price">{eur(p.compare_price)}</span>}
        <span className="text-xs font-bold bg-[#DC2626] text-white px-2 py-1 rounded-full">-{p.bundle_pct} %</span>
      </div>
      <button disabled={!ready} onClick={pick} data-testid="pack-add-to-cart"
        className="mt-5 w-full flex items-center justify-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] disabled:bg-slate-300 text-white font-display font-bold text-lg rounded-full py-3 transition-colors">
        <ShoppingBag size={19} /> {ready ? "Añadir pack al carrito" : "Elige las tallas"}
      </button>
    </div>
  );
};
